// components/BranchLocations.js
import React from "react";
import dynamic from "next/dynamic";
import { MapPin, Phone, Clock } from "lucide-react";
// import {
//   div,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
// } from "/components/ui/div";

// Dynamic import with SSR disabled
const MapWithNoSSR = dynamic(() => import("./MapComponent"), { ssr: false });

// Example branches for cards
const branches = [
  {
    name: "Салбар - 1",
    address:
      "Баянзүрх дүүрэг 16-р хороолол 82-р цэцэрлэгийн чанх хойно Тэнүүн 7 апартмент 77А байр 2-р орцны хажуу хаалга ",
    phone: "+976 9699 6996",
    hours: "Мягмар-Ням: 10:00 - 20:00, Даваа: Амрана",
  },
  {
    name: "Салбар - 2",
    address:
      "Сонгинохайрхан дүүрэг 18-р хороо геологийн төв лабораторийн хойно геологи 210 апартмент",
    phone: "+976 9699 6996",
    hours: "Мягмар-Ням: 10:00 - 20:00, Даваа: Амрана",
  },
  {
    name: "Салбар - 3",
    address:
      "ХУД 23-р хороо Арцат 2 апартмент 1439 байр 62 тоот Хотын захиргааны зүүгээр дээш 300 метр яваад нүдэнд илхэн, зам дагуу харагдана.",
    phone: "+976 9699 6996",
    hours: "Мягмар-Ням: 10:00 - 20:00, Даваа: Амрана",
  },
  {
    name: "Салбар - 4",
    address: "Баянхонгор аймаг 10-р баг, Шинэ төгөл хотхон, 129-р байр  ",
    phone: "+976 8505 8300",
    hours: "Мягмар-Ням: 10:00 - 20:00, Даваа: Амрана",
  },
  {
    name: "Салбар - 5",
    address: "Өвөрхангай аймаг Саруул хотхон, 101-р байрв 1-2 тоот  ",
    phone: "+976 9900 7318",
    hours: "Мягмар-Ням: 10:00 - 20:00, Даваа: Амрана",
  },
];

const BranchLocations = () => {
  return (
    <section className="bg-background pb-8">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 mt-10">
          <h2 className="text-4xl font-bold mb-4 text-foreground">Салбарууд</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Ачаа хүлээлгэж өгөх салбаруудын байршил
          </p>
        </div>

        {/* Map */}
        <div className="max-w-6xl mx-auto h-[500px] rounded-lg overflow-hidden shadow-lg">
          <MapWithNoSSR />
        </div>
      </div>
    </section>
  );
};

export default BranchLocations;
